<div class="reset-container">
  <mat-card class="reset-card">

    <!-- Mensaje de error -->
    <div *ngIf="!tokenValid && !successMessage">
      <div class="error-message">
        <mat-icon>error</mat-icon>
        <span>{{ errorMessage }}</span>
      </div>
    </div>

    <!-- Mensaje de éxito -->
    <div *ngIf="successMessage">
      <div class="success-message">
        <mat-icon>check_circle</mat-icon>
        <span>{{ successMessage }}</span>
      </div>
    </div>

    <!-- Formulario -->
    <div *ngIf="tokenValid && !successMessage">
      <div class="icon-wrapper">
        <mat-icon class="lock-icon">lock</mat-icon>
      </div>

      <h2>Cambiar Contraseña</h2>
      <p>Ingresa tu nueva contraseña de forma segura</p>

      <form [formGroup]="resetForm">

        <!-- Nueva Contraseña -->
        <label class="field-label">Nueva Contraseña</label>
        <div class="custom-input-wrapper">
          <input
            [type]="hidePassword ? 'password' : 'text'"
            formControlName="password"
            (keyup.enter)="confirmAction('submit')"
            autocomplete="new-password"
          />
          <button
            type="button"
            class="input-toggle-btn"
            (click)="togglePasswordVisibility('password')"
            aria-label="Toggle password visibility"
          >
            <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
        </div>
        <div class="error-message" *ngIf="password?.hasError('required') && (password?.touched || password?.dirty)">
          La contraseña es obligatoria
        </div>
        <div class="error-message" *ngIf="password?.hasError('minlength') && (password?.touched || password?.dirty)">
          La contraseña debe tener al menos 8 caracteres
        </div>
        <div class="error-message" *ngIf="password?.hasError('passwordComplexity') && (password?.touched || password?.dirty)">
          Debe incluir mayúscula, minúscula, número y símbolo
        </div>

        <!-- Confirmar Contraseña -->
        <label class="field-label">Confirmar Nueva Contraseña</label>
        <div class="custom-input-wrapper">
          <input
            [type]="hideConfirmPassword ? 'password' : 'text'"
            formControlName="confirmPassword"
            (keyup.enter)="confirmAction('submit')"
            autocomplete="new-password"
          />
          <button
            type="button"
            class="input-toggle-btn"
            (click)="togglePasswordVisibility('confirm')"
            aria-label="Toggle confirm password visibility"
          >
            <mat-icon>{{ hideConfirmPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
        </div>
        <div class="error-message" *ngIf="resetForm.hasError('passwordsNotMatching') && (confirmPassword?.dirty || confirmPassword?.touched)">
          Las contraseñas no coinciden
        </div>

        <p class="error-message" *ngIf="errorMessage && tokenValid">{{ errorMessage }}</p>

        <!-- Botones -->
        <div class="button-group">
          <button
            mat-raised-button
            class="save-btn"
            type="button"
            [disabled]="resetForm.invalid || resetForm.hasError('passwordsNotMatching')"
            (click)="confirmAction('submit')"
          >
            Guardar
          </button>

          <button mat-raised-button class="cancel-btn" type="button" (click)="confirmAction('cancel')">
            Cancelar
          </button>
        </div>
      </form>
    </div>
  </mat-card>
</div>

<!-- MODAL CASERO -->
<div *ngIf="showModal" class="modal-backdrop">
  <div class="modal-content">
    <p>
      {{ modalAction === 'submit' ? '¿Estás seguro que deseas cambiar la contraseña?' :
                                  '¿Seguro que deseas cancelar el cambio de contraseña y anular este enlace?' }}
    </p>
    <div class="modal-buttons">
      <button mat-raised-button class="save-btn" (click)="proceedAction()">Sí</button>
      <button mat-raised-button class="cancel-btn" (click)="closeModal()">No</button>
    </div>
  </div>
</div>
